import { makeServerRequest } from './util';

const apiPrefix = "api/v1/dashboard";

export function fetchDashboardSuccess(dashboard) {
    return {
        type: "FETCH_DASHBOARD_SUCCESS",
        payload: dashboard
    }
}

export function fetchDashboardFailure(error) {
    return {
        type: "FETCH_DASHBOARD_FAILURE",
        payload: error
    }
}

export const fetchDashboard = () => {
    return (dispatch) => {
        dispatch({type: "FETCH_DASHBOARD"});
        return makeServerRequest(apiPrefix).then(
            response => dispatch(fetchDashboardSuccess(response.data))
        ).catch(
            error => dispatch(fetchDashboardFailure(error))
        )
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/dashboard.js